<template>
    <div style="height: 100%">
        <div class="sa-flexbox" style="padding-bottom: 20px">
            <div class="sa-flexbox-header">
                <!-- <b-form @submit.prevent="onSubmit">
          <b-row style="margin-left: 0.5rem; margin-right: 0.5rem">
          </b-row>
        </b-form> -->
            </div>
            <div class="sa-flexbox-body">
                <div class="b-table-sticky-header">
                    <span class="sa-flexbox-body-title">Riunioni</span>
                    <b-button size="sm" variant="outline-success outline-primary-noborder sa-margin-right float-sm-right" @click="onClickNuovaRiunione" class="mb-2">
                        <font-awesome-icon icon="plus"> </font-awesome-icon>
                        Aggiungi
                    </b-button>
                    <b-table sticky-header ref="table" stacked="lg" striped hover :items="items" :fields="fields" :current-page="1" :per-page="perPage" :key="listKey" sort-icon-left head-variant="light" class="sa-b-table">
                        <template v-slot:cell(membri)="{ item }">
                            <span class="sa-label-data" v-for="equipe in item.listaDettaglio" :key="equipe.id"> {{ equipe.nome + " " + equipe.cognome + " (" + equipe.tipo + ") " }}</span>
                        </template>

                        <template v-slot:cell(dataOra)="{ item }">
                            <span>{{ formatDateTime(item.dataOra) }}</span>
                        </template>
                        <template v-slot:cell(verbale)="{ item }">
                            <span v-html="item.verbale"></span>
                        </template>
                        <template v-slot:cell(action)="row">
                            <b-container class="bv-example-row">
                                <b-button v-if="row.item.listaDettaglio.length > 0" size="sm" v-b-tooltip.hover title="Info" variant="outline-primary" @click="onClickInfo(row.item)">
                                    <font-awesome-icon icon="info-circle" />
                                </b-button>
                            </b-container>
                        </template>
                    </b-table>
                </div>
            </div>
            <div class="sa-flexbox-footer" style="background-color: ciano">
                <b-row class="sa-label-info" style="margin-left: 0.5rem; margin-right: 0.5rem">
                    <b-col lg="3">
                        <p>{{ this.$i18n.t("patients.lblTotalRecords") }}: {{ rows }}</p>
                    </b-col>
                    <b-col lg="9">
                        <b-pagination v-model="currentPage" :total-rows="rows" :per-page="perPage" align="right" size="sm"></b-pagination>
                    </b-col>
                </b-row>
            </div>
        </div>
        <rsa-paziente-riunione-equipe-modal-edit-component ref="cmpRsaPazienteRiunioneEquipeEdit" @afterSave="onAfterSave"></rsa-paziente-riunione-equipe-modal-edit-component>
        <rsa-paziente-riunione-equipe-modal-view-component ref="cmpRsaPazienteRiunioneEquipeView"></rsa-paziente-riunione-equipe-modal-view-component>
    </div>
</template>
<script>
import UtilityMixin from "../../../utility/UtilityMixin";
import RsaPazienteRiunioneEquipeModalEditComponent from "../components/RsaPazienteRiunioneEquipeModalEditComponent.vue";
import RsaPazienteRiunioneEquipeModalViewComponent from "./RsaPazienteRiunioneEquipeModalViewComponent.vue";

export default {
    mixins: [UtilityMixin],
    components: {
        RsaPazienteRiunioneEquipeModalEditComponent,
        RsaPazienteRiunioneEquipeModalViewComponent,
    },
    data() {
        return {
            rows: 0,
            perPage: 50,
            btnonClickNuovaRiunioneHidden: false,
            currentPage: 1,
            filtro: {},
            items: [],
            idAccettazione: null,
            jsonDataAccettazione: {},
            listKey: 0,
            pathResource: "/rsapazienteriunioneequipe",
            linkedit: "/",
            fields: [
                {
                    label: "Membri",
                    key: "membri",
                    thStyle: "width: 45rem",
                },
                {
                    label: "Data Ora",
                    key: "dataOra",
                },
                {
                    label: "Compilatore",
                    key: "createUser",
                },
                {
                    label: "Verbale",
                    key: "verbale",
                },
                { class: "sa-table-column-action-double", key: "action", label: "" },
            ],
        };
    },
    mounted() {},
    watch: {
        currentPage() {
            let me = this;
            me.loadData();
        },
    },
    methods: {
        init(jsonDataAccettazione) {
            let me = this;
            me.jsonDataAccettazione = {};
            me.jsonDataAccettazione = jsonDataAccettazione;
            me.idAccettazione = me.jsonDataAccettazione.id;
            me.loadData();
        },
        loadData() {
            let me = this;
            me.filtro.idAccettazione = me.idAccettazione;
            me.filtro.page = me.currentPage;
            me.filtro.forPage = me.perPage;
            UtilityMixin.methods.loadDataResources(me.pathResource, me.filtro, me.resultResponse, me.resultError);
        },
        resultResponse(response) {
            let me = this;
            me.rows = response.data.data.recordsNumber;
            me.items = response.data.data.list;
        },
        resultError(error) {
            console.log(error);
        },
        onClickNuovaRiunione() {
            let me = this;
            if (me.jsonDataAccettazione.statoAttuale === "DIMESSO" || me.jsonDataAccettazione.statoAttuale === "TRASFERITO") {
                me.$bvModal.msgBoxOk("Non è possibile questa operazione su un paziente dimesso", {
                    title: "ATTENZIONE",
                    size: "sm",
                    okVariant: "outline-danger",
                    headerClass: "sa-msg-header-danger",
                    footerClass: "p-2 border-top-0",
                    centered: true,
                });
                return;
            }
            me.$refs.cmpRsaPazienteRiunioneEquipeEdit.init(me.jsonDataAccettazione);
        },
        onAfterSave() {
            let me = this;
            me.loadData();
        },
        onClickInfo(item) {
            let me = this;
            me.$refs.cmpRsaPazienteRiunioneEquipeView.init(item.id);
        },
    },
};
</script>
